<div class="section" *ngIf="staff.length !== 0">
  <div class="title">{{title}}</div>
  <div class="panel">
    <div *ngFor="let tournamentTeamUser of staff" class="user-card">
      <div class="photo">
        <a [routerLink]="getUserRoute(tournamentTeamUser.leaguePlayer.id)" queryParamsHandling="preserve">
          <img [src]="tournamentTeamUser.leaguePlayer.photo.path" *ngIf="tournamentTeamUser.leaguePlayer.photo.path" class="circle-image"/>
          <div class="empty-photo" *ngIf="!tournamentTeamUser.leaguePlayer.photo.path">
            {{ tournamentTeamUser.leaguePlayer.initials }}
          </div>
        </a>
      </div>
      <div class="info">
        <a [routerLink]="getUserRoute(tournamentTeamUser.leaguePlayer.id)" queryParamsHandling="preserve">
          <h4>
            {{ tournamentTeamUser.leaguePlayer.shortName }}<span
            class="text-muted">&nbsp;{{tournamentTeamUser.teamUser.number ? '#&nbsp;' + tournamentTeamUser.teamUser.number : ''}}</span>
          </h4>
          <div class="text-muted">{{tournamentTeamUser.teamUser.role | localization: teamUserRolesLocalization}}</div>
        </a>
      </div>
    </div>
  </div>
</div>


